"use client";

import { Suspense } from "react";
import { AuthFlow } from "@/components/auth/auth-flow";
import LoginForm from "@/components/forms/login-form";
import { AuthStep } from "@/app/auth/auth-store";
import { requestLoginOtp, handleOtpResend, loginWithEmailOtp } from "../auth-actions";
import { useAuthStore } from "@/app/auth/auth-store";

export function LoginClient() {
  const setAuthStep = useAuthStore((s: any) => s.setAuthStep);
  const setEmail = useAuthStore((s: any) => s.setEmail);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AuthFlow
        initialStep={AuthStep.LOGIN}
        FormComponent={LoginForm}
        formProps={{
          onSubmit: async (email: string) => {
            const { error } = await requestLoginOtp(email);
            if (!error) {
              setEmail(email);
              setAuthStep(AuthStep.OTP);
            }
            return { error };
          },
          onSubmitOtp: loginWithEmailOtp,
          onResendOtp: handleOtpResend,
        }}
        toggleType="login"
      />
    </Suspense>
  );
}
